import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { EquipmentPatch } from "@/hooks/use-equipment-mutations";
import { newInsuranceDate, renewalDate, type InsuranceState } from "@/lib/equipment/insurance";
import type { DBEquipmentItem } from "@/lib/db-types";

interface InsuranceRowActionsProps {
  item: DBEquipmentItem;
  state: InsuranceState;
  today: string;
  disabled: boolean;
  onPatch: (patch: EquipmentPatch, message: string) => void;
}

/** Forny / Ikke forny for det som utløper; Forsikre / Selg eller utranger for det som ikke er forsikret. */
export function InsuranceRowActions({ item, state, today, disabled, onPatch }: InsuranceRowActionsProps) {
  const forsikre = () =>
    onPatch({ insured_until: newInsuranceDate(today), insurance_declined: false }, `${item.name} er forsikret`);

  if (state === "expiring" || state === "insured") {
    return (
      <div className="flex justify-end gap-1.5">
        <Button
          size="sm"
          variant="outline"
          disabled={disabled}
          onClick={() =>
            onPatch({ insured_until: renewalDate(item.insured_until, today), insurance_declined: false }, `${item.name} er fornyet`)
          }
        >
          Forny
        </Button>
        <Button size="sm" variant="ghost" disabled={disabled} onClick={() => onPatch({ insurance_declined: true }, `${item.name} fornyes ikke`)}>
          Ikke forny
        </Button>
      </div>
    );
  }
  if (state === "not_insured") {
    return (
      <div className="flex justify-end gap-1.5">
        <Button size="sm" variant="outline" disabled={disabled} onClick={forsikre}>
          Forsikre
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button size="sm" variant="ghost" disabled={disabled}>
              Selg / utranger
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onSelect={() => onPatch({ status: "sold" }, `${item.name} er merket som solgt`)}>Solgt</DropdownMenuItem>
            <DropdownMenuItem onSelect={() => onPatch({ status: "retired" }, `${item.name} er utrangert`)}>Utrangert</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
  }
  // Ute av oversikten: «Ikke forny» kan angres; solgt og utrangert endres på utstyrskortet.
  if (item.insurance_declined && item.status !== "sold" && item.status !== "retired") {
    return (
      <div className="flex justify-end">
        <Button size="sm" variant="outline" disabled={disabled} onClick={forsikre}>
          Forsikre
        </Button>
      </div>
    );
  }
  return null;
}
